var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogs"},_vm._l((_vm.messages),function(message,i){return _c('dialog-box',{key:((message.id) + "-" + (message.isOpened ? 'read' : 'unread')),staticClass:"dialog-item",attrs:{"message":message,"data-index":i}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef202c52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/Dialogs.vue
// module id = null
// module chunks = 